export default function ContatoNewsLetter() {
    const contatoFormSubmit = document.querySelector('#form-submit-rn')
    const btnSubmit = document.querySelector(".news-letter-form .btn-form-news-letter")

    if (!contatoFormSubmit || !btnSubmit) return;

    async function showMessage(response) {
        const message = response.data ? response.data.status : response.message
        GLOBAL.showToastify(message)

        contatoFormSubmit.reset()

        setTimeout(() => enableDisableBtn(true), 1000)
    }

    function enableDisableBtn(state) {
        btnSubmit.disabled = state
        btnSubmit.style.opacity = state ? "1.0" : "0.5"
    }

    function handleSubmitForm(e) {
        e.preventDefault()

        enableDisableBtn(false)

        const formValue = new FormData(e.currentTarget)
        const url = e.currentTarget.dataset.action

        axios.post(url, formValue)
            .then((response) => showMessage(response))
            .catch((response) => showMessage(response));
    }

    contatoFormSubmit.addEventListener('submit', handleSubmitForm);
}